import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const ClientBankAccount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Official Client Bank Accounts"
        description="Verify the official designated client bank accounts of Gateway Financial Services Limited for secure fund transfers and trading dealings."
      />

      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Client Bank Account</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <p>
                “Investors are requested to note that ‘Gateway Financial
                Services Limited’ is permitted to receive/pay money from/to
                investor through designated bank accounts only named as client
                bank accounts. ‘Gateway Financial Services Limited’ is also
                required to disclose these client bank accounts to Stock
                Exchange. Hence, you are requested to use following client bank
                accounts only for the purpose of dealings in your trading
                account with us. The details of these client bank accounts are
                also displayed by Stock Exchanges on their website under “Know /
                Locate your Stock Broker”.
              </p>

              <table className="table dwn-tbl table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Name of the Bank</th>
                    <th scope="col" className="text-left">
                      Account Number
                    </th>
                    <th scope="col">Name of the Bank Account</th>
                    <th scope="col">IFSC Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>AXIS BANK LTD</td>
                    <td className="text-left">911020003439781</td>
                    <td>GATEWAY FINANCIAL SERVICES LIMITED - USCNB ACCOUNT</td>
                    <td>UTIB0001138</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="#download"
                className="lm-btn"
                onClick={(e) => e.preventDefault()}
              >
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default ClientBankAccount;
